import { Box } from '@material-ui/core';

interface IShoppingCartCounter {
  totalProductsCounter: number;
}

const ShoppingCartCounter: React.FC<IShoppingCartCounter> = ({
  totalProductsCounter,
}) => {
  if (totalProductsCounter === 0) return null;
  return (
    <Box
      style={{
        position: 'absolute',
        width: '22px',
        height: '22px',
        backgroundColor: '#C52E1F',
        borderRadius: '100px',
        top: '-5px',
        right: '-7px',
        border: '2px solid #fff',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {totalProductsCounter}
    </Box>
  );
};

export default ShoppingCartCounter;
